// @flow
import { handleActions, type ActionType } from 'redux-actions';
import {
  fetchClientProperties,
  storeClientProperties,
} from './clientPropertiesActions';
import { Map } from 'immutable';
import AsyncValues, { type AsyncValueType } from 'lib/async-value';
import { type ClientProperty, type PropertyMap } from './types';

type State = AsyncValueType<PropertyMap>;

export default handleActions(
  {
    [fetchClientProperties.toString()]: (
      state: State,
      action: ActionType<typeof fetchClientProperties>
    ) => AsyncValues.Pending,
    [storeClientProperties.toString()]: (
      state: State,
      action: ActionType<typeof storeClientProperties>
    ) => {
      if (action.error) {
        return action.payload;
      }

      return parseRawProperties(action.payload);
    },
  },
  null
);

function parseRawProperties(list: Array<ClientProperty>): PropertyMap {
  const isNumberRegex = /^\d+$/;

  return Map(
    list.map(({ key, data_type, value: rawValue }) => {
      let value = rawValue.trim();

      if (data_type === 'boolean') {
        value = rawValue === 'true' ? true : false;
      } else if (data_type === 'number' || isNumberRegex.test(rawValue)) {
        value = +rawValue;
      } else {
        value = rawValue;
      }

      return [key, value];
    })
  );
}



// WEBPACK FOOTER //
// ./src/containers/client/clientPropertiesReducer.js